import { createRouter } from '@tanstack/react-router';
import { routeTree } from '../routeTree.gen';
import { store } from './store';

// Create the router instance with route tree
export const router = createRouter({
  routeTree,
  context: {
    store,
  },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

// Register router type for maximum type-safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
